import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminIntroduceMenus = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_MENUS.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroduceMenuById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_MENUS.GET_BY_ID(id));
    return response.data;
};
export const createIntroduceMenu = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_MENUS.CREATE, data);
    return response.data;
};
export const updateIntroduceMenu = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_MENUS.UPDATE(id), data);
    return response.data;
};
export const deleteIntroduceMenu = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_MENUS.DELETE(id));
    return response.data;
};

// Introduce Overviews
export const getAdminIntroduceOverviews = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_OVERVIEWS.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroduceOverviewById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_OVERVIEWS.GET_BY_ID(id));
    return response.data;
};
export const createIntroduceOverview = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_OVERVIEWS.CREATE, data);
    return response.data;
};
export const updateIntroduceOverview = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_OVERVIEWS.UPDATE(id), data);
    return response.data;
};
export const deleteIntroduceOverview = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_OVERVIEWS.DELETE(id));
    return response.data;
};

// Introduce Capacities
export const getAdminIntroduceCapacities = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_CAPACITIES.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroduceCapacityById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_CAPACITIES.GET_BY_ID(id));
    return response.data;
};
export const createIntroduceCapacity = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_CAPACITIES.CREATE, data);
    return response.data;
};
export const updateIntroduceCapacity = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_CAPACITIES.UPDATE(id), data);
    return response.data;
};
export const deleteIntroduceCapacity = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_CAPACITIES.DELETE(id));
    return response.data;
};

// Introduce Messages
export const getAdminIntroduceMessages = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_MESSAGES.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroduceMessageById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_MESSAGES.GET_BY_ID(id));
    return response.data;
};
export const createIntroduceMessage = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_MESSAGES.CREATE, data);
    return response.data;
};
export const updateIntroduceMessage = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_MESSAGES.UPDATE(id), data);
    return response.data;
};
export const deleteIntroduceMessage = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_MESSAGES.DELETE(id));
    return response.data;
};

// Introduce Foundationals
export const getAdminIntroduceFoundationals = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_FOUNDATIONALS.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroduceFoundationalById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_FOUNDATIONALS.GET_BY_ID(id));
    return response.data;
};
export const createIntroduceFoundational = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_FOUNDATIONALS.CREATE, data);
    return response.data;
};
export const updateIntroduceFoundational = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_FOUNDATIONALS.UPDATE(id), data);
    return response.data;
};
export const deleteIntroduceFoundational = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_FOUNDATIONALS.DELETE(id));
    return response.data;
};


// Introduce Visions
export const getAdminIntroduceVisions = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_VISIONS.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroduceVisionById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_VISIONS.GET_BY_ID(id));
    return response.data;
};
export const createIntroduceVision = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_VISIONS.CREATE, data);
    return response.data;
};
export const updateIntroduceVision = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_VISIONS.UPDATE(id), data);
    return response.data;
};
export const deleteIntroduceVision = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_VISIONS.DELETE(id));
    return response.data;
};

// Introduce Orientations
export const getAdminIntroduceOrientations = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_ORIENTATIONS.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroduceOrientationById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_ORIENTATIONS.GET_BY_ID(id));
    return response.data;
};
export const createIntroduceOrientation = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_ORIENTATIONS.CREATE, data);
    return response.data;
};
export const updateIntroduceOrientation = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_ORIENTATIONS.UPDATE(id), data);
    return response.data;
};
export const deleteIntroduceOrientation = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_ORIENTATIONS.DELETE(id));
    return response.data;
};

// Introduce Cultures
export const getAdminIntroduceCultures = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_CULTURES.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroduceCultureById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_CULTURES.GET_BY_ID(id));
    return response.data;
};
export const createIntroduceCulture = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_CULTURES.CREATE, data);
    return response.data;
};
export const updateIntroduceCulture = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_CULTURES.UPDATE(id), data);
    return response.data;
};
export const deleteIntroduceCulture = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_CULTURES.DELETE(id));
    return response.data;
};

// Introduce Policies
export const getAdminIntroducePolicies = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_POLICIES.GET_ALL, { params });
    return response.data;
};
export const getAdminIntroducePolicyById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.INTRODUCE_POLICIES.GET_BY_ID(id));
    return response.data;
};
export const createIntroducePolicy = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.INTRODUCE_POLICIES.CREATE, data);
    return response.data;
};
export const updateIntroducePolicy = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.INTRODUCE_POLICIES.UPDATE(id), data);
    return response.data;
};
export const deleteIntroducePolicy = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.INTRODUCE_POLICIES.DELETE(id));
    return response.data;
};
